module.exports = __webpack_public_path__ + "static/media/img_12.faf861c6.png";